module.exports = __webpack_public_path__ + "img/flappy-bird-full-website-4.0fee316d.png";